export default "__VITE_ASSET__DgsRSVXS__"